/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommunicationDto } from '../../models/communication-dto';

export interface UpdateCommunication$Params {
  communicationId: number;
      body: CommunicationDto
}

export function updateCommunication(http: HttpClient, rootUrl: string, params: UpdateCommunication$Params, context?: HttpContext): Observable<StrictHttpResponse<CommunicationDto>> {
  const rb = new RequestBuilder(rootUrl, updateCommunication.PATH, 'put');
  if (params) {
    rb.path('communicationId', params.communicationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CommunicationDto>;
    })
  );
}

updateCommunication.PATH = '/communications/{communicationId}';
